/* src/app/feature/details.component.scss */
:host {
  width: 100%;
  margin-bottom: 15px;
  display: block;
}
.input-container.required {
  background-color: yellow;
}
.control-container {
  width: 100%;
  margin-bottom: 5px;
  padding: 5px 20px;
}
.control-container input[type=text],
.control-container input[type=number],
.control-container input[type=email],
.control-container textarea,
.control-container select {
  border: 1px solid #eee;
  padding-left: 15px;
  outline: 0;
  min-width: 100%;
  color: #373f44;
  vertical-align: bottom;
  background: 0 0;
  font-size: 15px;
  min-height: 40px;
}
.control-container input[type=text]:disabled,
.control-container input[type=number]:disabled,
.control-container input[type=email]:disabled,
.control-container textarea:disabled,
.control-container select:disabled {
  color: #92969a;
}
.control-container textarea {
  padding-top: 15px;
  min-height: 100px;
}
.control-container.required {
  background-color: rgba(240, 255, 0, 0.1);
}
.box-input,
.select-container select {
  border-radius: 2px;
  border: 1px solid #eee;
  height: 37px;
}
.select-container select {
  padding-left: 15px;
  background: url(/assets/images/caret.svg) no-repeat right;
  background-position: calc(100% - 15px) 50%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.control-title {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #475056;
  margin-bottom: 6px;
}
.control-title.disabled {
  color: #92969a;
}
.control-title img {
  width: 15px;
  margin-right: 10px;
}
.control-title .required-badge {
  margin-left: 10px;
  background-color: yellow;
  padding: 3px 5px;
  border-radius: 5px;
  float: right;
  font-size: 10px;
}
.control-subtitle {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #475056;
  margin-bottom: 12px;
}
.control-subtitle.disabled {
  color: #92969a;
}
.feature-symbol {
  margin-right: 5px;
  margin-bottom: 4px;
  height: 25px;
  width: 25px;
}
.date-picker-container {
  position: relative;
}
.date-picker-container .picker-icon {
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
}
/*# sourceMappingURL=details.component.css.map */
